import type { PlayerProfileResponse } from '@on3/api';
import { webUrl } from '@on3/ui-lib/utils/api';

import styles from './PlayerHeader.module.scss';

export const PlayerHeader = ({
  basicInfo,
}: {
  basicInfo?: PlayerProfileResponse;
}) => {
  const {
    name,
    defaultAsset,
    classYear,
    positionAbbreviation,
    height,
    weight,
    hometownName,
    slug,
  } = basicInfo || {};

  return (
    <header className={styles.header}>
      <h1 className={styles.heading}>{name}</h1>
      <img
        alt={defaultAsset?.altText || 'Default Avatar'}
        className={styles.avatar}
        height="60"
        src={`https://${defaultAsset?.domain}${defaultAsset?.source}`}
        width="60"
      />
      <div className={styles.playerData}>
        <span className={styles.data}>{classYear || '-'}</span>
        <span className={styles.data}>{positionAbbreviation || '-'}</span>
        <span className={styles.data}>{height || '-'}</span>
        <span className={styles.data}>{weight || '-'}</span>
        <span className={styles.data}>{hometownName || '-'}</span>
      </div>
      <a
        className={styles.profileButton}
        href={`${webUrl}/rivals/${slug}/`}
        rel="noopener noreferrer"
        target="_blank"
      >
        View Player Profile
      </a>
    </header>
  );
};
